import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { EnvService } from 'src/app/env.service';
import * as _ from 'underscore';

import { Storage, getDownloadURL, ref } from '@angular/fire/storage';
import { SkillztankCalendarEvent } from 'src/app/shared/models/event.model';
import { TodosService } from '../todos/todos.service';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class AppCalendarService {
  private calendarEventSource = new Subject<any>();
  calendarEvents$ = this.calendarEventSource.asObservable();

  public events: SkillztankCalendarEvent[];
  storage;

  colors: any = {
    red: {
      primary: '#f44336',
      secondary: '#FAE3E3',
    },
    blue: {
      primary: '#247ba0 ',
      secondary: '#D1E8FF',
    },
    yellow: {
      primary: '#ffd97d',
      secondary: '#FDF1BA',
    },
  };

  BASE_URL;
  userid = (JSON.parse(localStorage.getItem('userData')) || { id: '' }).id;

  public newEventUsersSource: BehaviorSubject<Array<any>> = new BehaviorSubject([]);

  newEventUsers$ = this.newEventUsersSource.asObservable();

  constructor(
    private http: HttpClient,
    private env: EnvService,
    private todoService: TodosService
  ) {
    this.BASE_URL = `${env.apiUrl}`;
    this.storage = inject(Storage);
  }

  async getDownloadURL(url) {
    try {
      const reference = ref(this.storage, url);
      return await getDownloadURL(reference);
    } catch (error) {
      return 'assets/images/no_user.png';
    }
  }

  async updateNewEventUsers(data) {
    if (data.length > 0) {
      for (const e of data) {
        if (e.type == 'group') {
          e.photo = 'assets/images/no_user.png';
          e.image = 'assets/images/no_user.png';
        } else {
          e.photo = await this.getDownloadURL(e.photo);
          e.image = e.photo || 'assets/images/no_user.png';
        }
      }

      this.newEventUsersSource.next(data);
    } else {
      this.newEventUsersSource.next(data);
    }
  }

  addUsersInNewEvent(dataObj) {
    const currentValue = this.newEventUsersSource.value;
    const updatedValue = [...currentValue, dataObj];
    this.newEventUsersSource.next(updatedValue);
  }

  removeUsersInNewEvent(dataObj) {
    const currentValue = this.newEventUsersSource.value;

    const index = currentValue.findIndex((e) => e.id == dataObj.id);
    if (index > -1) {
      if (currentValue.length > 2) {
        currentValue.splice(index, 1);
      } else if (currentValue.length == 2) {
        currentValue.splice(index, 1);
        currentValue[0].role = 'Admin';
        currentValue[0].userRole = 'Admin';
      } else {
        currentValue[0].role = 'Admin';
        currentValue[0].userRole = 'Admin';
      }
    }

    this.newEventUsersSource.next(currentValue);
  }

  public getEvents(): Observable<any> {
    return this.http.get(`${this.BASE_URL}calendar/getEvents`, httpOptions);
  }

  public sendCalendarEvent(event) {
    this.calendarEventSource.next(event);
  }
  public addEvent(event): Observable<any> {
    event.users = event.users.map((user) => {
      if (user._id) {
        user.id = user._id;
      }
      return _.pick(user, ['id', 'type', 'role']);
    });
    return this.http.post(`${this.BASE_URL}calendar/create`, event, httpOptions).pipe(tap((res) => this.todoService.triggerTodoChangeEvent()));
  }

  public deleteEventModel(event): Observable<any> {
    return this.http.post(`${this.BASE_URL}calendar/deleteModel`, event, httpOptions).pipe(tap((res) => this.todoService.triggerTodoChangeEvent()));
  }

  public updateEvent(event): Observable<any> {
    event.users = event.users.map((user) => {
      if (user._id) {
        user.id = user._id;
      }
      return _.pick(user, ['id', 'type', 'role']);
    });

    return this.http.post(`${this.BASE_URL}calendar/edit/?id=${event._id}`, event, httpOptions).pipe(
      tap((res) => {
        this.todoService.triggerTodoChangeEvent();
      })
    );
  }

  public updateEventNameAndDescription(event): Observable<any> {
    return this.http.post(`${this.BASE_URL}calendar/editNameAndDescription?eventid=${event._id}`, event, httpOptions).pipe(tap((res) => this.todoService.triggerTodoChangeEvent()));
  }

  public getContentEvent(contentID) {
    return this.http.get(`${this.BASE_URL}calendar/getContentEvents/?id=${contentID}`, httpOptions);
  }

  public getEventMembers(eventID) {
    return this.http.get(`${this.BASE_URL}calendar/getEventMembers/?id=${eventID}`, httpOptions);
  }

  public deleteEvent(eventID: string): Observable<any> {
    return this.http.get(`${this.BASE_URL}calendar/remove/?id=${eventID}`, httpOptions).pipe(tap((res) => this.todoService.triggerTodoChangeEvent()));
  }

  public deleteAllOccurrenceOfEvent(eventID: string): Observable<any> {
    return this.http.get(`${this.BASE_URL}calendar/remove-all-occurrences-of-event/?id=${eventID}`, httpOptions).pipe(tap((res) => this.todoService.triggerTodoChangeEvent()));
  }

  public getRecentEvents(start, end): Observable<any> {
    const userGroups = _.pluck(JSON.parse(localStorage.getItem('userGroups')), '_id');
    return this.http.get(this.BASE_URL + `calendar/getRecentEvents?startDate=${start}&endDate=${end}&userGroups=${userGroups}`, httpOptions);
  }
}
